import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { UserProfile } from './auth.service';

/** Ключът, под който приложението помни избрания език между сесиите. */
export const LANG_STORAGE_KEY = 'lang';

/**
 * Езикът, на който влиза този потребител, или `null` — тогава остава текущият.
 *
 * Собственикът влиза в портала на предпочитания си език, а не на езика на
 * екрана за вход: иначе Иван (bg) получава английски портал. Служителят влиза
 * в администрацията и остава на езика, който си е избрал. Във „Виж портала му“
 * езикът също е на гледащия, защото той чете — затова правилото е при входа,
 * а не в портала.
 */
export function entryLanguage(profile: UserProfile | null): 'bg' | 'en' | null {
  if (profile?.role !== 'owner') return null;
  return profile.owner?.preferred_language ?? null;
}

@Injectable({ providedIn: 'root' })
export class EntryLanguageService {
  private readonly transloco = inject(TranslocoService);

  /** Прилага езика при вход; ръчната смяна след това остава в сила до следващия вход. */
  apply(profile: UserProfile | null): void {
    const lang = entryLanguage(profile);
    if (!lang) return;
    this.transloco.setActiveLang(lang);
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  }
}
